import { render, staticRenderFns } from "./AppMenuConnect.vue?vue&type=template&id=df60929a&"
import script from "./AppMenuConnect.vue?vue&type=script&lang=js&"
export * from "./AppMenuConnect.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports